module.exports = __webpack_public_path__ + "static/media/helpdesk.7b5a587e.png";